import React, {useContext} from "react";
import {connect} from "react-redux";
import ContractsContext from "./contractsContext";
import {getReceiptFieldStyles} from "./receiptFieldPositionFunctions";
import {setReceiptHomeDepotFields} from "../../../actions/printFunctions";
import {RECEIPT_PAGE_RENDER_SCALE} from "./contractInterface";
import {
  RECEIPT_WORK_ORDER_FIELD_HEIGHT,
  RECEIPT_WORK_ORDER_FIELD_WIDTH
} from "../printPopup/styles/printDocumentStylesHomeDepot";

// keep in sync with the markers set on the matching Views in printDocumentHeader.js / printDocumentInfoHomeDepotFields.js
// / printDocumentHomeDepotCentralText.js. width/height are no longer hardcoded here - getReceiptFieldStyles()
// sizes each overlay input from its marked View's own measured box (scaled to match the rendered page), except
// receiptWorkOrderNumber which passes a defaultSize because its marker View has no explicit width - see
// RECEIPT_WORK_ORDER_FIELD_WIDTH/HEIGHT in printDocumentStyles.js for why.
const HOME_DEPOT_FIELDS = [
  {
    name: "receiptWorkOrderNumber", marker: "receiptWorkOrderNumberField",
    defaultSize: {width: RECEIPT_WORK_ORDER_FIELD_WIDTH, height: RECEIPT_WORK_ORDER_FIELD_HEIGHT},
    translateX: 241
  },
  {name: "receiptHDLeadNumber", marker: "receiptHDLeadNumberField"},
  {name: "receiptBathroomLocation", marker: "receiptBathroomLocationField"},
  {name: "receiptEstimateStart", marker: "receiptEstimateStartField"},
  {name: "receiptEstimatedText", marker: "receiptEstimatedTextField", translateX: 75},
];

/**
 * Interactive text inputs overlaid on top of the rendered receipt (page 1), shown only while signing
 * (fabricatorData.receiptSettings?.homeDepotReceipt). Mirrors receiptSign.js's approach for the signature field,
 * but for plain text values instead of a drawn image - values are written straight to printState as the person
 * types, and only get baked into the actual generated PDF (see printDocument*.js) once isContractSign is false.
 **/
const ReceiptHomeDepotFields = (props) => {

  const {printState, setReceiptHomeDepotFields} = props;
  const {receiptLayout, globalContractPage} = useContext(ContractsContext);

  const handleChange = (fieldName, event) => {
    setReceiptHomeDepotFields({[fieldName]: event.target.value});
  }

  return (
    <>
      {HOME_DEPOT_FIELDS.map((homeDepotField) => {
        const {name, marker, defaultSize, translateX} = homeDepotField;
        const styles = getReceiptFieldStyles(receiptLayout, globalContractPage - 1, marker,
          RECEIPT_PAGE_RENDER_SCALE, defaultSize, translateX);
        return (
          <input className="regular contract-body__custom-text-field"
                 key={name}
                 style={styles}
                 value={printState[name] || ""}
                 onChange={(event) => handleChange(name, event)}/>
        )
      })}
    </>
  )
};

const mapStateToProps = (store) => {
  const {receiptWorkOrderNumber, receiptHDLeadNumber, receiptBathroomLocation, receiptEstimateStart,
    receiptEstimatedText} = store.printState;
  return {
    printState: {receiptWorkOrderNumber, receiptHDLeadNumber, receiptBathroomLocation, receiptEstimateStart,
      receiptEstimatedText},
  };
};

const mapDispatchToProps = {
  setReceiptHomeDepotFields,
};

export default connect(mapStateToProps, mapDispatchToProps)(ReceiptHomeDepotFields)
